import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LpCountriesUsToGermanyComponent } from '../pages/us-to-germany/us-to-germany.component';
import { ShopAndShipCarouselComponent } from '../components/carousel/carousel.component';
import { ShopAndShipRoutingModule } from './shop-and-ship-routing.module';
import { register } from 'swiper/element/bundle';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShopAndShipAccordionComponent } from '../components/accordion/accordion.component';
import { ShopAndShipTabsComponent } from '../components/tabs/tabs.component';
import { ShopAndShipHeroComponent } from '../components/hero-jumbotron/hero-jumbotron.component';
import { ShopAndShipBrandsGridComponent } from '../components/brands-grid/brands-grid.component';
import { ShopAndShipAdvantagesComponent } from '../components/advantages/advantages.component';
import { ShopAndShipPriceCalculationComponent } from '../components/price-calculation/price-calculation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LpCountriesUsToAustraliaComponent } from '../pages/us-to-australia/us-to-australia.component';
import { ShopAndShipPageComponent } from '../pages/shop-and-ship-page/shop-and-ship-page.component.';
import { ShopAndShipToCountryPageComponent } from '../pages/to-country-page/to-country-page.component.';
import { ShopAndShipHeroForToCountryComponent } from '../components/to-country/hero-jumbotron/hero-jumbotron.component';
import { ShopAndShipWhyChooseShippnForToCountryComponent } from '../components/to-country/why-choose-shippn/why-choose-shippn.component';
import { ShopAndShipHowItWorksComponent } from '../components/to-country/how-it-works/how-it-works.component';
import { ShopAndShipServiceOptionsComponent } from '../components/to-country/service-options/service-options.component';
import { ShopAndShipPriceCalculationToCountryComponent } from '../components/to-country/price-calculation-to-country/price-calculation-to-country.component';
register();
@NgModule({
  declarations: [
    ShopAndShipPageComponent,
    ShopAndShipCarouselComponent,
    ShopAndShipAccordionComponent,
    LpCountriesUsToGermanyComponent,
    ShopAndShipTabsComponent,
    ShopAndShipHeroComponent,
    ShopAndShipBrandsGridComponent,
    ShopAndShipAdvantagesComponent,
    ShopAndShipPriceCalculationComponent,
    LpCountriesUsToAustraliaComponent, 
    ShopAndShipToCountryPageComponent,
    ShopAndShipHeroForToCountryComponent,
    ShopAndShipWhyChooseShippnForToCountryComponent, 
    ShopAndShipHowItWorksComponent,
    ShopAndShipServiceOptionsComponent,
    ShopAndShipPriceCalculationToCountryComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ShopAndShipRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShopAndShipModule {}
